import { render, staticRenderFns } from "./ModifyFile.vue?vue&type=template&id=aedad504&"
import script from "./ModifyFile.vue?vue&type=script&lang=js&"
export * from "./ModifyFile.vue?vue&type=script&lang=js&"
import style0 from "./ModifyFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports